// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"contentWrapper-172ii","paper":"paper-1v74B"};